import Ad from "../../../../Ad/component";
import { LOADMORE_AD_TYPE, NATIVE_AD_TYPE } from "../../../../Ad/constants";
import { update_page_native_ad } from "../../../../../actions/Page/dispatchers";
import { useDispatch } from "react-redux";

export const LoadMoreAd = () => {
    return (
        <div className="adCardWrapper">
            <Ad type="load-more" lazy targeting={{ plc: "more" }} />
        </div>
    );
};

export const FLPNativeAd = (props) => {
    const dispatch = useDispatch();

    const nativeAdCallback = (isNativeAdEmpty) => {
        isNativeAdEmpty &&
            dispatch(update_page_native_ad({ hasNativeAd: false }));
    };

    return <Ad type="native-ad" callback={nativeAdCallback} {...props} />;
};

export const DATA_TYPE_MAPPING = {
    //Always returns an Ad component for type native ad.
    [NATIVE_AD_TYPE]: () => FLPNativeAd,
    [LOADMORE_AD_TYPE]: () => LoadMoreAd,
};

export const getTypeKey = (contentData) =>
    contentData.hasOwnProperty("itemType") ? "itemType" : "type";

export const mapComponentFromType = (props) => {
    const { contentData, contentLayout } = props;
    const { ContentComponent } = contentLayout;
    let maybeComponent = undefined;

    // Polopoly items use "itemType" as the key for the type property while ads use "type". This abstracts away the difference.
    const typeKey = getTypeKey(contentData);

    if (contentData[typeKey] && contentData[typeKey] in DATA_TYPE_MAPPING) {
        const dataType = contentData[typeKey];
        const typeToComponentFunction = DATA_TYPE_MAPPING[dataType];
        //The type to component function may return a React component or not, hence it is a maybe component.
        maybeComponent = typeToComponentFunction({
            ...props,
        });
    }

    //This conditional return allows the type mapping function to only explicitly return a value  when the content component should be changed. Otherwise, it will result in no change to ContentComponent.
    return maybeComponent ? maybeComponent : ContentComponent;
};
